import { c as _c } from "react/compiler-runtime";
import React from 'react';
import loadable from '@loadable/component';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
const AnimateHeight = loadable(() => import('react-animate-height'));
const ProductListingClearAllFiltersButton = () => {
  const $ = _c(5);
  const {
    activeFilterCount,
    resetFilters
  } = useProductListingPageContext();
  const shouldShowButton = !!activeFilterCount;
  const t0 = shouldShowButton ? "auto" : 0;
  let t1;
  if ($[0] !== resetFilters) {
    t1 = <div className="md:pb-5"><ClearAllFiltersButton onClick={resetFilters}>Clear all</ClearAllFiltersButton></div>;
    $[0] = resetFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = <AnimateHeight duration={300} height={t0} animateOpacity={true}>{t1}</AnimateHeight>;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default ProductListingClearAllFiltersButton;